module.exports = __webpack_public_path__ + "img/20190701155311400.b6418acf.png";